import styled from 'styled-components';
export const PStyle = styled.p`
  font-size: 2rem;
  width: fit-content;

  padding: 0.5rem 1rem;
`;

export const LotCanvas = styled.canvas`
  max-width: 70vw;
  height: auto; 
`;

export const TimeH2 = styled.h2` 
  margin-top:10px;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  width: fit-content;
`;

export const ImageDiv = styled.div` 
  margin-top:2;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Button = styled.button`
  padding: 1rem 2rem; 
  font-size: 1.5rem;  
  margin: 0.5rem; 
`;

export const ButtonsDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LabelsDiv = styled.div`
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  max-width: 70vw;
`;

export const AdImage = styled.img`
  height: auto;
  width: 100%;
  transition: opacity 0.5s;
`;

export const AdBanner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
`;